var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoryReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.224 2.172a6.667 6.667 0 0 0-7.928 1.11L1.333 5.125V2.667a.667.667 0 1 0-1.333 0v4c0 .368.298.667.667.667h4a.667.667 0 0 0 0-1.334H2.35l1.867-1.754A5.333 5.333 0 1 1 2.969 9.78a.667.667 0 0 0-1.258.443 6.667 6.667 0 1 0 9.513-8.05zM8.667 4.667a.667.667 0 0 0-1.334 0v4c0 .253.143.484.369.597l2.666 1.333a.667.667 0 1 0 .597-1.193L8.667 8.255V4.667z",
    fill: "#A12512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryReset);
export default __webpack_public_path__ + "static/media/factoryReset.34d25e44931e42ca1af0b0a06a47a5af.svg";
export { ForwardRef as ReactComponent };